import request from "@/utils/request";
import store from "@/store";
import { getUserInfo, getSelectConfig } from "@/api/androidApi";

// 登录
export function login(data) {
  return request({
    url: "/api/v1/login",
    method: "post",
    data,
  });
}

// 重置密码
export function resetPassword(data) {
  return request({
    url: "/api/v1/resetPassword",
    method: "post",
    data,
  });
}

//基础数据
export function config() {
  return request({
    url: "/api/v1/config",
    method: "get",
  });
}

//用户信息
export function userinfo(token) {
  if (store.state.app.isAndroid) {
    return getUserInfo();
  }
  return request({
    url: "/api/v1/userinfo",
    method: "get",
    params: {
      token,
    },
  });
}

//列表配置
export function selectConfig(params) {
  if (store.state.app.isAndroid) {
    return getSelectConfig(params);
  }
  return request({
    url: "/api/v1/selectConfig",
    method: "get",
    params,
  });
}

export function unlock(params) {
  return request({
    url: "/api/v1/oyc/pro/unlock.html",
    method: "get",
    params,
  });
}
export function lock(params) {
  return request({
    url: "/api/v1/oyc/pro/lock.html",
    method: "get",
    params,
  });
}
export function pushModelData(data) {
  return request({
    url: "/api/v1/oyc/pro/pushModelData.html",
    method: "post",
    data,
  });
}

export function uperrormodel(data) {
  return request({
    url: "/api/v1/oyc/pro/uperrormodel.html",
    method: "post",
    data,
  });
}
